import { styled } from '@mui/material';
import { globalZindex } from 'core/common/constants';
import { Button, Container } from 'core/common/ui/ui-kit';

export const TimerWrapperStyled = styled('div')`
  position: fixed;
  top: 0;
  left: 0;
  z-index: ${globalZindex.banner};
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 65px;
  background: ${({ theme }) => theme.palette.contentBlockBackground.secondary};

  ${({ theme }) => theme.breakpoints.up('mobile')} {
    background: ${({ theme }) => theme.palette.contentBlockBackground.main};
  }
`;

export const TimerContainerStyled = styled(Container)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 16px;
  padding-left: 16px;
`;

export const ContentBlockStyled = styled(Container)`
  display: flex;
  flex-direction: column;
`;

export const ButtonStyled = styled(Button)`
  flex-shrink: 0;
  min-width: 140px;
`;
